import { useState } from 'react';
import type { EmailSignInStartResult } from '../lib/types';
import { ApiError, api } from '../lib/api';

/**
 * Sign-in for patients a clinic invited: an email address, then a one-time link. There is no
 * password. On a test deployment a link that could not be emailed is shown here instead.
 */
export function EmailSignIn() {
  const [email, setEmail] = useState('');
  const [busy, setBusy] = useState(false);
  const [result, setResult] = useState<EmailSignInStartResult | null>(null);
  const [error, setError] = useState<string | null>(null);
  return (
    <div className="email-signin">
      <div className="divider">Invited by your clinic?</div>
      <form
        className="form"
        onSubmit={async (e) => {
          e.preventDefault();
          if (!email.trim()) return;
          setBusy(true);
          setError(null);
          setResult(null);
          try {
            setResult(await api.emailStart(email.trim()));
          } catch (ex) {
            setError(ex instanceof ApiError ? ex.message : 'Could not send the link.');
          } finally {
            setBusy(false);
          }
        }}
      >
        <label className="field">
          <span>Email address your clinic has on file</span>
          <input type="email" value={email} autoComplete="email" maxLength={254} placeholder="you@example.com" onChange={(e) => setEmail(e.target.value)} disabled={busy} />
        </label>
        <button className="secondary full" type="submit" disabled={busy || !email.trim()}>
          {busy ? 'Sending…' : 'Email me a sign-in link'}
        </button>
      </form>
      {error ? <div className="form-error">{error}</div> : null}
      {result ? (
        <div className="notice" role="status">
          <p>{result.message}</p>
          {result.devNote ? <p className="hint small">{result.devNote}</p> : null}
          {result.devLink ? (
            <a className="button primary small" href={result.devLink}>
              Open the sign-in link
            </a>
          ) : null}
        </div>
      ) : null}
      <p className="hint small">New here? Open the invitation your clinic emailed you to create your account.</p>
    </div>
  );
}
